import { getFeedsReviewsType } from '@op/utils/text';
import {
  biggerOrTo,
  commentType,
  equalAndTo,
  formatTimeToFormat,
  getExtJsonValue,
  hideSentimentFunc,
  languageRenderHelper,
  monitorSourceName,
  tryTransNumber,
} from '../renderHelper';
import { gameInfoType } from '@op/types/common';

export const AnalysisMetricList = ({
  hideSentimentRating = false,
  gameInfo,
}: {
  hideSentimentRating: boolean;
  gameInfo?: gameInfoType;
}) => {
  const isNikke =
    gameInfo?.edition_unified_id === 'uef4312b08dde07820374dd57086ea2fb';
  const list = [
    {
      text: `Parent Comment Id`,
      header: `Parent Comment Id(Only replies have Parent_comment_id, which indicates the id of the post.
  Use the reply's Parent_comment_id to find all the replies of the post.
  Or use the comment_id of the post to find all the replies for that post.)`,
      value: 'comment_parent_id',
      renderHelper: [tryTransNumber, equalAndTo('-1', '')],
    },
    {
      text: 'Parent Comment Url',
      header: 'Parent Comment Url',
      value: 'parent_comment_url',
    },
    {
      text: 'Comment Id',
      header: 'Comment Id(Only posts have Comment Id)',
      value: 'comment_id',
      renderHelper: [tryTransNumber, equalAndTo('-1', '')],
    },
    {
      text: 'Comment Type',
      value: 'comment_type',
      renderHelper: [commentType],
    },
    {
      text: 'Comment Uin',
      value: 'comment_uin',
    },
    {
      text: 'Channel',
      value: 'channel_name',
    },
    {
      text: 'Monitor Source',
      value: 'monitor_source',
      renderHelper: [monitorSourceName],
    },
    {
      text: 'Review Type',
      value: 'reviews_type',
      renderHelper: [getFeedsReviewsType],
    },
    {
      text: 'Sentiment',
      value: 'sentiment_rating',
      numFmt: ['0.00'],
      renderHelper: [hideSentimentFunc(hideSentimentRating)],
    },
    {
      text: 'Reviewer',
      value: 'reviewer',
    },
    {
      text: 'Content Original',
      value: 'content',
    },
    {
      text: 'Content Chinese',
      value: 'content_to_zh',
    },
    {
      text: 'Content English',
      value: 'content_to_en',
    },
    {
      text: 'URL',
      value: 'content_url',
    },
    {
      text: 'Date-1',
      header: 'Date',
      value: 'comment_time',
      renderHelper: [formatTimeToFormat('YYYY-MM-DD')],
    },
    {
      text: 'Time(UTC+8:00)',
      value: 'comment_time',
      renderHelper: [formatTimeToFormat('YYYY-MM-DD HH:mm:ss')],
    },
    {
      text: 'Language',
      value: 'language',
      renderHelper: [languageRenderHelper],
    },
    {
      text: 'Topic',
      value: 'topic',
    },
    {
      text: 'Engagement',
      value: 'engagement',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      text: 'Like',
      value: 'tweets_like',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      text: 'Dislike',
      value: 'tweets_unlike',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      text: 'Share',
      value: 'tweets_retweet',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      text: 'Comment',
      value: 'tweets_reply',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      text: 'View',
      value: 'view',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      text: 'Subscribe',
      value: 'subscribe',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      text: 'Description',
      value: 'description',
    },
    {
      text: 'Keyword Included',
      value: 'keyword_included',
    },
  ];

  if (isNikke) {
    list.push(
      {
        text: 'PV',
        value: 'tweets_view',
        numFmt: '#,##',
        renderHelper: [biggerOrTo(0, '')],
      },
      {
        text: 'UV',
        value: 'ext_json',
        renderHelper: [
          getExtJsonValue({
            valueKey: 'nikke_expose_uv',
            dealwithList: [tryTransNumber, biggerOrTo(0, '')],
          }),
        ],
        numFmt: '#,##',
      },
    );
  }

  return list;
};
